import { IconProps } from "./";
import Icon from "./assets/mail_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Mail(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
